import { render, staticRenderFns } from "./processDetail.vue?vue&type=template&id=66641d74&"
import script from "./processDetail.vue?vue&type=script&lang=js&"
export * from "./processDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports